import React from 'react';
import { Link } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import FadeIn from '../components/FadeIn';

export default function EventsHub() {
  return (
    <main className="bg-brand-vintage pb-0">
      <SeoMeta 
        title="Private Events & Corporate Venue | Padua in Claremont, CA" 
        description="Host your next corporate event, private celebration, or Quinceañera at Padua. Discover our historic spaces, elevated catering, and concierge service." 
      />
      
      <PageHero 
        title="Gather & Celebrate" 
        subtitle="An elevated, historic venue for corporate events, private milestones, and Quinceañeras."
        image="https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Kelley-and-Faisal-109.jpg"
      />

      <section className="py-24 px-6 max-w-4xl mx-auto text-center">
        <FadeIn>
          <h2 className="font-serif text-3xl md:text-4xl text-brand-charcoal mb-8 font-light">
            Beyond the Wedding Day
          </h2>
          <p className="font-sans text-brand-charcoal/80 text-lg leading-relaxed font-light mb-12">
            While Padua is renowned as a premier wedding venue, our historic estate is also the perfect setting for significant milestones, corporate retreats, and private celebrations. We bring the same level of culinary excellence and concierge hospitality to every event we host.
          </p>
        </FadeIn>
      </section>

      <section className="py-24 bg-brand-aged px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <FadeIn>
             <div className="aspect-[4/3] overflow-hidden rounded-sm shadow-xl mb-8">
               <img src="https://ik.imagekit.io/aeu02xvjgn/26-padua-hills-theatre-claremont-persian-wedding-photography.jpg" alt="Corporate Events" className="w-full h-full object-cover" />
             </div>
             <h3 className="font-serif text-2xl text-brand-charcoal mb-4 font-light">Corporate Events</h3>
             <p className="font-sans text-brand-charcoal/80 leading-relaxed font-light mb-6 text-sm">
               Trade the sterile conference room for a historic estate. Perfect for executive dinners, company holiday parties, and retreats.
             </p>
             <Link to="/events/corporate" className="text-[10px] uppercase tracking-[0.25em] text-brand-olive border-b border-brand-olive pb-1 font-bold">Learn More</Link>
          </FadeIn>
          
          <FadeIn delay={0.2}>
             <div className="aspect-[4/3] overflow-hidden rounded-sm shadow-xl mb-8">
               <img src="https://ik.imagekit.io/aeu02xvjgn/34-padua-hills-theatre-claremont-persian-wedding-photography.jpg" alt="Quinceañeras" className="w-full h-full object-cover" />
             </div>
             <h3 className="font-serif text-2xl text-brand-charcoal mb-4 font-light">Quinceañeras</h3>
             <p className="font-sans text-brand-charcoal/80 leading-relaxed font-light mb-6 text-sm">
               Honor this beautiful coming-of-age milestone in a grand, architectural setting with exceptional photography backdrops and a spacious ballroom.
             </p>
             <Link to="/events/quinceaneras" className="text-[10px] uppercase tracking-[0.25em] text-brand-olive border-b border-brand-olive pb-1 font-bold">Learn More</Link>
          </FadeIn>

          <FadeIn delay={0.4}>
             <div className="aspect-[4/3] overflow-hidden rounded-sm shadow-xl mb-8">
               <img src="https://ik.imagekit.io/aeu02xvjgn/22-padua-hills-theatre-claremont-persian-wedding-photography-1600x1066.jpg" alt="Private Celebrations" className="w-full h-full object-cover" />
             </div>
             <h3 className="font-serif text-2xl text-brand-charcoal mb-4 font-light">Private Celebrations</h3>
             <p className="font-sans text-brand-charcoal/80 leading-relaxed font-light mb-6 text-sm">
               From significant anniversaries to grand birthday dinners, gather your loved ones in an intimate, private dining atmosphere.
             </p>
             <Link to="/events/private-events" className="text-[10px] uppercase tracking-[0.25em] text-brand-olive border-b border-brand-olive pb-1 font-bold">Learn More</Link>
          </FadeIn>
        </div>
      </section>

      <CTASection title="Inquire About Your Event" />
    </main>
  );
}